const origins = ['https://manage.wix.com', 'https://manage.editorx.com'];
const allowedOrigins = new Set(origins);
export const isWixOrigin = (origin: string) => allowedOrigins.has(origin);
